// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function HighlightSection__Jsx3(props) {
  var __children = props.children;
  var __background = props.background;
  var background = __background !== undefined ? __background : "Neutral";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var variantClass;
  switch (background) {
    case "Neutral" :
        variantClass = "bg-tan-old-lace text-zinc-600 border-zinc-300";
        break;
    case "Muted" :
        variantClass = "bg-zinc-50 text-zinc-600 border-zinc-300";
        break;
    case "Danger" :
        variantClass = "bg-tan-old-lace text-zinc-600 border-tan-error-500";
        break;
    
  }
  return JsxRuntime.jsx("section", {
              children: children,
              className: TailwindMerge.twMerge([
                    variantClass,
                    "font-normal text-base leading-tight rounded border p-4"
                  ])
            });
}

var make = HighlightSection__Jsx3;

exports.make = make;
/* tailwind-merge Not a pure module */
